import React, {Component} from 'react';
import {connect} from 'react-redux';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import {Card, CardContent} from '@material-ui/core';
import {getCookie, CookieName, setCookie} from '../utils/cookieManager';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import {MuiThemeProvider, createTheme} from '@material-ui/core/styles';
import {Config} from '../utils/Config';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputMask from 'react-input-mask';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import Dialog from '@material-ui/core/Dialog';
import '../App.scss';

const styles = () => ({
  root: {
    border: 'none',
    boxShadow: 'none',
    padding: '2px',
    backgroundColor: '#fafafa',
  },
  expansionPanelSummaryContent: {
    display: 'block',
    margin: '0 !important',
  },
  expansionPanelDetailContent: {
    padding: '8px',
  },
  radioBtnStyle: {
    paddingRight: '12px !important',
    paddingLeft: 0,
  },
  textField: {
    marginTop: 0,
  },
  paperStyle: {
    padding: '16px',
  },
  dialogCustomizedWidth: {
    'max-width': '95%',
    margin: '1rem',
  },
});

const theme = createTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiTypography: {
      root: {
        fontSize: '14px !important',
      },
    },
    MuiOutlinedInput: {
      root: {
        fontSize: '14px !important',
      },
      input: {
        padding: '10px',
      },
    },
  },
});

const MonthInput = (props) => {
  const {...other} = props;
  return <InputMask mask="99" maskChar={null} {...other} />;
};

const YearInput = (props) => {
  const {...other} = props;
  return <InputMask mask="99" maskChar={null} {...other} />;
};

const CVVInput = (props) => {
  const {...other} = props;
  return <InputMask mask="999" maskChar={null} {...other} />;
};

// const NameInput = props => {
//   const { ...other } = props;
//   return <InputMask mask="a" maskChar={null} {...other} />;
// };

// const isEmpty = (obj) =>
//   Object.keys(obj).length === 0 && obj.constructor === Object;

const getQueryParams = (name, url) => {
  if (!url) {
    const blockRes = this.props.location.state.blockRes;
    url = blockRes.bookingUrl;
  }

  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regexS = '[\\?&]' + name + '=([^&#]*)';
  var regex = new RegExp(regexS);
  var results = regex.exec(url);
  return results === null ? '' : results[1];
};

class TicketSummary extends Component {
  isVisited = false;
  constructor(props) {
    super(props);
    this.state = {
      isSnackBarOpen: false,
      isShowFareDetail: false,
      paymentGateway: 'payu',
      walletPoints: 0,
      travelInsuranceCharge: 0,
      finalPayableAmount: 0,
      selectedPaymentMethod: '',
      dcNumber: '',
      dcNumberErr: false,
      dcNumberErrTxt: '',
      dcExpMonth: '',
      dcExpMonthErr: false,
      dcExpMonthErrTxt: '',
      dcExpYear: '',
      dcExpYearErr: false,
      dcExpYearErrTxt: '',
      dcCVV: '',
      dvCVVErr: false,
      dcCVVErrTxt: '',
      dcName: '',
      dcNameErr: false,
      dcNameErrTxt: '',
      ccNumber: '',
      ccNumberErr: false,
      ccNumberErrTxt: '',
      ccExpMonth: '',
      ccExpMonthErr: false,
      ccExpMonthErrTxt: '',
      ccExpYear: '',
      ccExpYearErr: false,
      ccExpYearErrTxt: '',
      ccCVV: '',
      ccCVVErr: false,
      ccCVVErrTxt: '',
      ccName: '',
      ccNameErr: false,
      ccNameErrTxt: '',
      bankcode: '',
      netBankingList: {},
      gPayBankHandle: '',
      gPayBankHandleErr: false,
      gPayBankHandleErrTxt: '',
      upiBankHandle: '',
      upiBankHandleErr: false,
      upiBankHandleErrTxt: '',
      isloading: false,
      isGobackDialogOpen: false,
      cardMask: {
        mask: '9999 9999 9999 9999',
      },
      cardType: '',
      isDialogOpen: false,
    };
    if (getCookie('Paymentvisit') || !this.props.history.location.state) {
      console.log('going to seat-layout page');
      this.props.history.goBack();
    }
  }

  removeDisabledBtn = () => {
    const element = document.getElementsByClassName('ctkt-btn-success-bottom');
    element[0].classList.remove('disabled', 'opacity');
  };

  addDisabledBtn = () => {
    const element = document.getElementsByClassName('ctkt-btn-success-bottom');
    element[0].classList.add('disabled', 'opacity');
  };

  componentDidMount() {
    // if (!getCookie("Paymentvisit")) {
    // When User wants to go back
    console.log(this.props.history.location.state);

    if (getCookie('Paymentvisit') || !this.props.history.location.state) {
      console.log('going to passsenger page');
      // this.props.history.replace("/buses/seat-select");
      this.props.history.goBack();
    } else {
      window.history.pushState(null, null, window.location.href);
      window.onpopstate = (e) => {
        console.log('Going Back');
        e.preventDefault();
        this.setState({
          isGobackDialogOpen: true,
        });
        // window.history.go(1);
      };
    }

    // }

    if (this.props.location.state) {
      const blockRes = this.props.location.state.blockRes;
      const travelInsurance = this.props.location.state.travelInsurance;
      const passengercount = this.props.location.state.blockTicketrequest
        .inventoryItems.length;
      // console.log(passengercount);
      // console.log(blockRes);

      this.setState({
        travelInsuranceCharge: travelInsurance ? 15 * passengercount : 0,
      });
      const token = getCookie(CookieName.USERTOKEN);
      // const phone = this.props.ticketdetailsReducer.mobile;
      const totalamount = getQueryParams('totalFare', blockRes.pgURL);
      const url = `${Config.SECURED_API_HOST}/api/platform/trainbooking/GetWalletPoints?userKey=${token}`;
      fetch(url)
        .then((res) => res.json())
        .then((res) => {
          console.log(res);

          // toFixed will return a string
          const twoDecimal = res.Points
            ? parseFloat(parseFloat(res.Points / 100).toFixed(2))
            : 0;
          //totalamount = totalamount - twoDecimal;
          let finalPayableAmount =
            totalamount - twoDecimal + this.state.travelInsuranceCharge;
          if (totalamount <= twoDecimal) {
            finalPayableAmount = 0;
          }
          this.setState({
            walletPoints: twoDecimal,
            totalamount: totalamount,
            finalPayableAmount,
          });
        })
        .catch((error) => {
          this.openSnackBar('Unable to get wallet points');
          console.error('Error:', error);
        });

      const getNetBankingStatusURL = `${Config.SECURED_API_HOST}/api/platform/getNetbankingStatusPayu`;
      fetch(getNetBankingStatusURL)
        .then((response) => response.json())
        .then((res) => {
          const netBankingList = Object.keys(res)
            .sort()
            .reduce((accumulator, currentKey) => {
              if (res[currentKey].up_status === 1) {
                accumulator[currentKey] = res[currentKey];
              }
              return accumulator;
            }, {});

          let bankcode;
          if (Object.keys(netBankingList).length > 0) {
            bankcode =
              netBankingList[Object.keys(netBankingList)[0]].ibibo_code;
          } else {
            bankcode = '';
          }

          this.setState({netBankingList, bankcode});
          //console.log(netBankingList);
        });
    } else {
      this.props.history.replace('/rbooking-bus/seat-select');
    }
  }

  handleDialogClose = () => {
    this.setState({
      isDialogOpen: false,
      isGobackDialogOpen: false,
    });
  };

  handleDialogOpen = () => {
    this.setState({
      isDialogOpen: true,
    });
  };

  CardInput = (props) => {
    const {...other} = props;
    const {cardMask} = this.state;
    return <InputMask {...cardMask} maskChar=" " {...other} />;
  };

  openSnackBar = (message) => {
    const msg = (
      <div className="snackbar-msg" id="message-id">
        {message}
      </div>
    );
    this.setState({isSnackBarOpen: true, message: msg});
  };

  handleChange = (name) => (event) => {
    // debugger;
    // const props = this.props;
    // const walletAmout = this.state.walletPoints;
    // const blockRes = props.location.state.blockRes;

    if (name === 'dcNumber' || name === 'ccNumber') {
      // debugger;
      const value = event.target.value;
      let cardType = '';
      const {cardMask} = this.state;
      if (/^3[47]/.test(value)) {
        cardMask.mask = '9999 999999 99999';
        cardType = 'amex';
      } else {
        cardMask.mask = '9999 9999 9999 9999';
        cardType = 'visa_master';
      }
      this.setState({
        [name]: event.target.value,
        [`${name}Err`]: false,
        [`${name}ErrTxt`]: null,
        cardType,
        cardMask,
      });
    } else {
      this.setState({
        [name]: event.target.value,
        [`${name}Err`]: false,
        [`${name}ErrTxt`]: null,
      });
    }
    // console.log(this.state);
  };

  handleClose = () => {
    this.setState({isSnackBarOpen: false});
  };

  redirectWithPost = (url, data) => {
    // debugger;
    const formElement = document.createElement('form');
    formElement.name = 'redirectWithPost';
    formElement.method = 'POST';
    formElement.action = url;

    if (data) {
      Object.keys(data).forEach((key) => {
        const inputElement = document.createElement('input');
        inputElement.type = 'hidden';
        inputElement.name = key;
        inputElement.value = data[key];
        formElement.appendChild(inputElement);
      });
      document.body.appendChild(formElement);
      formElement.submit();
    }
  };

  validateCardDetails = (method) => {
    if (method === 'TEZ') {
      if (this.state.gPayBankHandle.trim().length === 0) {
        this.setState({
          gPayBankHandleErr: true,
          gPayBankHandleErrTxt: 'Please enter Google Pay id',
        });
        this.removeDisabledBtn();
        return false;
      }
      return true;
    } else if (method === 'upi') {
      if (this.state.upiBankHandle.trim().length === 0) {
        this.setState({
          upiBankHandleErr: true,
          upiBankHandleErrTxt: 'Please enter UPI id',
        });
        this.removeDisabledBtn();
        return false;
      }
      return true;
    } else {
      // debugger;
      if (this.state[`${method}Number`].trim().length === 0) {
        this.setState({
          [`${method}NumberErr`]: true,
          [`${method}NumberErrTxt`]: 'Please enter card number',
        });
        this.removeDisabledBtn();
        return false;
      }

      if (this.state.cardType === 'amex') {
        if (this.state[`${method}Number`].trim().length < 17) {
          this.setState({
            [`${method}NumberErr`]: true,
            [`${method}NumberErrTxt`]: 'Not a valid card number',
          });
          this.removeDisabledBtn();
          return false;
        }
      } else {
        if (this.state[`${method}Number`].trim().length < 19) {
          this.setState({
            [`${method}NumberErr`]: true,
            [`${method}NumberErrTxt`]: 'Not a valid card number',
          });
          this.removeDisabledBtn();
          return false;
        }
      }

      if (this.state[`${method}ExpMonth`].trim().length === 0) {
        this.setState({
          [`${method}ExpMonthErr`]: true,
          [`${method}ExpMonthErrTxt`]: 'Please enter expiry month',
        });
        this.removeDisabledBtn();
        return false;
      } else if (
        this.state[`${method}ExpMonth`].trim() === '0' ||
        this.state[`${method}ExpMonth`] === '00'
      ) {
        this.setState({
          [`${method}ExpMonthErr`]: true,
          [`${method}ExpMonthErrTxt`]: 'Not a valid month',
        });
        this.removeDisabledBtn();
        return false;
      } else if (this.state[`${method}ExpMonth`] > 12) {
        this.setState({
          [`${method}ExpMonthErr`]: true,
          [`${method}ExpMonthErrTxt`]: 'Not a valid month',
        });
        this.removeDisabledBtn();
        return false;
      }

      if (this.state[`${method}ExpYear`].trim().length === 0) {
        this.setState({
          [`${method}ExpYearErr`]: true,
          [`${method}ExpYearErrTxt`]: 'Please enter expiry year',
        });
        this.removeDisabledBtn();
        return false;
      } else if (this.state[`${method}ExpYear`].trim().length < 2) {
        this.setState({
          [`${method}ExpYearErr`]: true,
          [`${method}ExpYearErrTxt`]: 'Not a valid year',
        });
        this.removeDisabledBtn();
        return false;
      } else if (
        this.state[`${method}ExpYear`].trim() <
        new Date().getFullYear().toString().slice(2)
      ) {
        this.setState({
          [`${method}ExpYearErr`]: true,
          [`${method}ExpYearErrTxt`]: 'Card expired',
        });
        this.removeDisabledBtn();
        return false;
      }
      return true;
    }
  };

  redirectPayment = () => {
    const Provider = this.props.searchQuery.seatapidata.bus.Provider;
    const finalPayableAmount = this.state.finalPayableAmount;
    const blockRes = this.props.location.state.blockRes;
    const tempToken = getCookie(CookieName.USERTEMPTOKEN);
    const prebookingId = getQueryParams('prebookingid', blockRes.pgURL);
    const amount = getQueryParams('totalFare', blockRes.pgURL);
    const name = getQueryParams('name', blockRes.pgURL);
    const phone = getQueryParams('phone', blockRes.pgURL);
    const email = getQueryParams('email', blockRes.pgURL);
    let redirectURL = '';
    let busProvider = '';

    if (Provider === 'APSRTC') {
      busProvider = '&busProvider=APSRTC';
    }

    if (this.state.selectedPaymentMethod !== '') {
      this.addDisabledBtn();
      const method = this.state.selectedPaymentMethod.toLowerCase();
      if (this.state.selectedPaymentMethod !== 'PayPal') {
        redirectURL = `https://www.confirmtkt.com/paymenthandler/payu-seamless-bus.php?prebookingid=${prebookingId}&amount=${amount}&firstname=${name}&phone=${phone}&email=${email}&usewalletpts=${
          this.state.walletPoints * 100
        }${busProvider}&channel=mweb-bus`;
        if (this.state.selectedPaymentMethod === 'CC') {
          if (this.validateCardDetails(method)) {
            this.setState({isloading: true});
            const ccNumber = this.state.ccNumber.split(' ').join('');
            const validateCardURL = `https://securedapi.confirmtkt.com/api/platform/getCardDetailsPayu?cardNo=${ccNumber}`;
            fetch(validateCardURL)
              .then((res) => res.json())
              .then((res) => {
                console.log(res);
                if (res) {
                  if (res.cardCategory === 'CC') {
                    const {
                      selectedPaymentMethod,
                      ccNumber,
                      ccName,
                      ccExpYear,
                      ccExpMonth,
                      ccCVV,
                    } = this.state;

                    const redirectPostData = {
                      pg: selectedPaymentMethod,
                      ccnum: ccNumber,
                      ccname: ccName,
                      ccvv: ccCVV,
                      ccexpmon: ccExpMonth,
                      ccexpyr: ccExpYear,
                    };
                    setCookie('Paymentvisit', true);
                    this.redirectWithPost(redirectURL, redirectPostData);
                  } else {
                    this.setState({isloading: false});
                    this.removeDisabledBtn();
                    alert(`Please enter valid Card Number`);
                  }
                } else {
                  this.setState({isloading: false});
                  this.removeDisabledBtn();
                  alert(`Something went wrong! Please try again.`);
                }
              })
              .catch((err) => {
                this.setState({isloading: false});
                this.removeDisabledBtn();
                alert(`Something went wrong! Please try again.`);
              });
          } else {
            return;
          }
        } else if (this.state.selectedPaymentMethod === 'DC') {
          if (this.validateCardDetails(method)) {
            this.setState({isloading: true});
            const dcNumber = this.state.dcNumber.split(' ').join('');
            console.log(dcNumber);
            const validateCardURL = `https://securedapi.confirmtkt.com/api/platform/getCardDetailsPayu?cardNo=${dcNumber}`;
            console.log(validateCardURL);
            fetch(validateCardURL)
              .then((res) => res.json())
              .then((res) => {
                if (res) {
                  if (res.cardCategory === 'DC') {
                    const {
                      selectedPaymentMethod,
                      dcNumber,
                      dcName,
                      dcExpYear,
                      dcExpMonth,
                      dcCVV,
                    } = this.state;

                    const redirectPostData = {
                      pg: selectedPaymentMethod,
                      ccnum: dcNumber,
                      ccname: dcName,
                      ccvv: dcCVV,
                      ccexpmon: dcExpMonth,
                      ccexpyr: dcExpYear,
                    };
                    setCookie('Paymentvisit', true);
                    this.redirectWithPost(redirectURL, redirectPostData);
                  } else {
                    this.setState({isloading: false});
                    this.removeDisabledBtn();
                    alert(`Please enter valid Card Number`);
                  }
                } else {
                  this.setState({isloading: false});
                  this.removeDisabledBtn();
                  alert(`Something went wrong! Please try again.`);
                }
              })
              .catch((err) => {
                this.setState({isloading: false});
                this.removeDisabledBtn();
                alert(`Something went wrong! Please try again.`);
              });
          } else {
            return;
          }
        } else if (this.state.selectedPaymentMethod === 'NB') {
          const {selectedPaymentMethod, bankcode} = this.state;

          const redirectPostData = {
            pg: selectedPaymentMethod,
            bankcode,
          };
          this.redirectWithPost(redirectURL, redirectPostData);
        } else if (
          this.state.selectedPaymentMethod === 'TEZ'
          // ||this.state.selectedPaymentMethod === "upi"
        ) {
          debugger;
          const {
            selectedPaymentMethod,
            gPayBankHandle,
            // upiBankHandle,
          } = this.state;
          if (this.validateCardDetails(selectedPaymentMethod)) {
            this.setState({isloading: true});
            let vpa;
            if (selectedPaymentMethod === 'TEZ') {
              vpa = `${gPayBankHandle}`;
            } else {
              // vpa = `${upiBankHandle}`;
            }

            const validateVPAURL = `https://securedapi.confirmtkt.com/api/platform/validateVPA?vpa=${vpa}`;
            fetch(validateVPAURL)
              .then((res) => res.json())
              .then((res) => {
                if (res.status === 'SUCCESS') {
                  if (res.isVPAValid === 1) {
                    const redirectPostData = {
                      pg: 'UPI',
                      bankcode: selectedPaymentMethod,
                      vpa,
                    };
                    setCookie('Paymentvisit', true);
                    this.redirectWithPost(redirectURL, redirectPostData);
                  } else {
                    this.setState({isloading: false});
                    this.removeDisabledBtn();
                    if (selectedPaymentMethod === 'TEZ') {
                      alert(`Please enter valid Google Pay Id`);
                    } else {
                      alert(`Please enter valid UPI Id`);
                    }
                  }
                } else {
                  this.setState({isloading: false});
                  this.removeDisabledBtn();
                  alert(`Something went wrong! Please try again.`);
                }
              })
              .catch((err) => {
                this.setState({isloading: false});
                this.removeDisabledBtn();
                alert(`Something went wrong! Please try again.`);
              });
          } else {
            return;
          }
        } else if (this.state.selectedPaymentMethod === 'mipay') {
          this.setState({isloading: true});
          const paymentUrlFetch = `https://securedapi.confirmtkt.com/api/platform/miPayInitiatetransaction?transactionId=${prebookingId}&type=bus&walletUsed=true`;
          fetch(paymentUrlFetch)
            .then((res) => res.json())
            .then((res) => {
              if (res.completeWallet) {
                //full wallet
              } else {
                //redirect to payment gateway
                window.open(res.URL, '_self');
              }
            });
        } else {
          redirectURL = `${redirectURL}&pg=${this.state.selectedPaymentMethod}`;
          // console.log(redirectURL);
          window.open(redirectURL, '_self');
        }
      } else {
        this.setState({isloading: true});
        redirectURL = `https://www.confirmtkt.com/booking/paypal-wallet/payment-create.php?prebookingid=${prebookingId}&amount=${amount}&firstname=${name}&phone=${phone}&email=${email}&tempToken=${tempToken}&usewalletpts=${
          this.state.walletPoints * 100
        }${busProvider}&channel=mweb-bus`;
        setCookie('Paymentvisit', true);
        window.open(redirectURL, '_self');
      }
    } else if (finalPayableAmount === 0) {
      this.setState({isloading: true});
      redirectURL = `https://www.confirmtkt.com/paymenthandler/payu-seamless-bus.php?prebookingid=${prebookingId}&amount=${amount}&firstname=${name}&phone=${phone}&email=${email}&usewalletpts=${
        this.state.walletPoints * 100
      }${busProvider}&channel=mweb-bus`;
      this.addDisabledBtn();
      setCookie('Paymentvisit', true);
      const data = {
        payment: 'fullwallet',
      };
      this.redirectWithPost(redirectURL, data);
    } else {
      this.removeDisabledBtn();
      this.openSnackBar('Please select at least one payment option!');
    }
  };

  handleExpansion = (panel) => (isExpanded) => {
    // debugger;
    let selectedPaymentMethod = '';
    if (panel === 'panel1') {
      selectedPaymentMethod = 'DC';
    } else if (panel === 'panel2') {
      selectedPaymentMethod = 'CC';
    } else if (panel === 'panel3') {
      selectedPaymentMethod = 'TEZ';
    } else if (panel === 'panel4') {
      selectedPaymentMethod = 'upi';
    } else if (panel === 'panel5') {
      selectedPaymentMethod = 'PayPal';
    } else if (panel === 'panel6') {
      selectedPaymentMethod = 'NB';
    } else if (panel === 'panel7') {
      selectedPaymentMethod = 'lazypay';
    } else if (panel === 'panel8') {
      selectedPaymentMethod = 'mipay';
    }
    this.setState({
      expanded: panel,
      setExpanded: isExpanded ? panel : false,
      selectedPaymentMethod,
    });
  };

  handlePopularBank = (bankcode) => {
    this.setState({
      bankcode,
    });
  };

  openpromt = () => {
    this.setState({
      isGobackDialogOpen: true,
    });
  };

  render() {
    const blockRes = this.props.ticketdetailsReducer;
    // const passenger = blockRes.passengerdetails;
    const {walletPoints, finalPayableAmount} = this.state;
    const {classes} = this.props;
    // console.log(blockRes);

    const bus = blockRes.bus;
    const boarding = blockRes.boarding;
    const JourneyDetails = this.props.searchQuery;
    const from = JourneyDetails.source.city;
    const to = JourneyDetails.destination.city;
    const doj = JourneyDetails.doj;

    var date = new Date(doj);
    let boardingPt = boarding.Time + ' ' + boarding.Name;
    //console.log(dropping.Time);
    var DepartureTime = bus.DeparturePoints[0].Time.split(':');
    var boardingTime = boarding.Time.split(':');
    if (DepartureTime[0] > boardingTime[0]) {
      date = new Date(doj);
      date.setDate(date.getDate() + 1);
      // console.log(date);
    }

    const bankList = Object.keys(this.state.netBankingList).map(
      (item, index) => {
        return (
          <option
            key={index}
            value={this.state.netBankingList[item].ibibo_code}
          >
            {this.state.netBankingList[item].title}
          </option>
        );
      }
    );

    const GobacktoSeatLayout = (
      <Dialog
        open={this.state.isGobackDialogOpen}
        onClose={this.handleDialogClose}
        maxWidth="xl"
        fullWidth
      >
        <div className="fare-details">
          <h4>Are You sure You Want to go back ?</h4>
          <hr />
          <Grid
            container
            justifyContent="flex-start"
            className="fare-details-content"
          >
            <span style={{fontSize: '14px'}}>
              Your selected seats are already blocked! You need to select
              different seats if you go back.
            </span>
            <br />
            <span>
              Note: Your selected seats will be available after a While.
            </span>
            <Grid item xs={12} className="text-right">
              <button
                style={{margin: '5px'}}
                className="btn btn-default "
                onClick={this.handleDialogClose}
              >
                Cancel
              </button>
              <button
                style={{margin: '5px'}}
                className="btn btn-success"
                onClick={(e) => this.props.history.goBack()}
              >
                Go Back
              </button>
            </Grid>
          </Grid>
        </div>
      </Dialog>
    );

    const fareDetailsDialog = (
      <Dialog
        open={this.state.isDialogOpen}
        onClose={this.handleDialogClose}
        maxWidth="xl"
        fullWidth
        classes={{paperFullWidth: classes.dialogCustomizedWidth}}
      >
        <div className="fare-details">
          <h3>Fare Details</h3>
          <hr />
          <Grid
            container
            justifyContent="flex-start"
            className="fare-details-content"
          >
            <Grid item xs={6}>
              Ticket Fare
            </Grid>
            <Grid item xs={6} className="right-column">
              &nbsp;&nbsp;:&nbsp;&nbsp;₹ {this.state.totalamount}
            </Grid>
            {/* <Grid item xs={6}>
              Travel Insurance Premium
            </Grid>
            <Grid item xs={6} className="right-column">
              &nbsp;&nbsp;:&nbsp;&nbsp;₹ {this.state.travelInsuranceCharge}
            </Grid> */}
            <Grid item xs={6}>
              Wallet Points
            </Grid>
            <Grid item xs={6} className="right-column">
              &nbsp;&nbsp;:&nbsp;&nbsp;₹{this.state.walletPoints}
            </Grid>
          </Grid>
          <Grid container className="grand-total-container">
            <Grid item xs={6}>
              <span className="total-fare">Grand Total</span>
              <br />
              <span>Inclusive of GST</span>
            </Grid>
            <Grid item xs={6} className="right-column">
              <span className="total-fare">
                &nbsp;&nbsp;:&nbsp;&nbsp;₹ {finalPayableAmount}
              </span>
            </Grid>
            <Grid item xs={12} className="text-right">
              <strong
                className="close-dialog-btn"
                onClick={this.handleDialogClose}
              >
                Close
              </strong>
            </Grid>
          </Grid>
        </div>
      </Dialog>
    );

    const displayBlock = (
      <div className="ticket-summary-container">
        <div className="route" style={{fontSize: '14px'}}>
          <Card style={{marginBottom: '1rem'}}>
            <CardContent>
              {/* <div>
                  <h3 style={{ color: "grey" }}>{bus.TravelsName}</h3>
                </div> */}

              {/* <Grid item xs={8} className="title">
                    <span>{bus.TravelsName}</span>
                  </Grid> */}

              <Grid container justifyContent="flex-start">
                <Grid item xs={6}>
                  <h4 style={{margin: '0', fontSize: '1.4rem'}}>
                    {from.split(',')[0]}
                  </h4>
                  <span style={{color: 'grey'}}>{from.split(',')[1]}</span>
                </Grid>
                <Grid item xs={1}>
                  <i className="material-icons">arrow_right_alt</i>
                </Grid>
                <Grid item xs={5} className="right-column">
                  <h4 style={{margin: '0', fontSize: '1.4rem'}}>
                    {to.split(',')[0]}
                  </h4>
                  <span style={{color: 'grey'}}>{to.split(',')[1]}</span>
                </Grid>
              </Grid>

              <hr />
              <div>
                <h4>{bus.TravelsName}</h4>
              </div>
              <Grid container justifyContent="flex-start">
                <Grid item xs={5}>
                  {/* <h4>Boarding Date</h4> */}
                  {'Boarding Date'}
                </Grid>
                <Grid item xs={7} className=" ">
                  {date.toDateString()}
                </Grid>
              </Grid>
              <Grid container justifyContent="flex-start">
                <Grid item xs={5}>
                  {/* <h4>Boarding Point</h4> */}
                  {'Boarding Point'}
                </Grid>
                <Grid item xs={7} className=" ">
                  {boardingPt}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          {walletPoints > 0 ? (
            <Card style={{marginBottom: '1rem'}}>
              <CardContent>
                <Grid container justifyContent="flex-start">
                  <Grid item xs={6}>
                    <span className="total-fare">Wallet Balance </span>
                  </Grid>
                  <Grid item xs={6} className="right-column">
                    <span className="total-fare">₹ {walletPoints}</span>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ) : (
            ''
          )}
        </div>

        {/* Paymnet Options list */}
        {finalPayableAmount === 0 ? (
          ''
        ) : (
          <Card>
            <CardContent>
              <h4 style={{marginBottom: '1.6rem'}}>
                Select any one payment option
              </h4>

              <MuiThemeProvider theme={theme}>
                {/* <ExpansionPanel
                  classes={{
                    root: this.props.classes.root,
                  }}
                  expanded={this.state.expanded === "panel5"}
                  onChange={this.handleExpansion("panel5")}
                >
                  <ExpansionPanelSummary
                    classes={{
                      root: this.props.classes.root,
                      content: this.props.classes.expansionPanelSummaryContent,
                    }}
                  >
                    <Radio
                      checked={this.state.selectedPaymentMethod === "PayPal"}
                      name="selectedPaymentMethod"
                      aria-label="A"
                      classes={{
                        root: this.props.classes.radioBtnStyle,
                      }}
                    />
                    {"PayPal  "}
                    <img
                      src="https://www.confirmtkt.com/cdn-images/payment/logo_paypal.png"
                      width={60}
                      height={20}
                      alt="paypal"
                      className="pgImg"
                    />
                    &nbsp;&nbsp;
                  </ExpansionPanelSummary>
                </ExpansionPanel> */}

                <ExpansionPanel
                  classes={{
                    root: this.props.classes.root,
                  }}
                  expanded={this.state.expanded === 'panel1'}
                  onChange={this.handleExpansion('panel1')}
                >
                  <ExpansionPanelSummary
                    classes={{
                      root: this.props.classes.root,
                      content: this.props.classes.expansionPanelSummaryContent,
                    }}
                  >
                    <Radio
                      checked={this.state.selectedPaymentMethod === 'DC'}
                      name="selectedPaymentMethod"
                      aria-label="A"
                      classes={{
                        root: this.props.classes.radioBtnStyle,
                      }}
                    />
                    Debit / ATM Card
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails
                    classes={{
                      root: this.props.classes.expansionPanelDetailContent,
                    }}
                  >
                    <Grid container>
                      {/* <Grid item xs={1} /> */}
                      <Grid item xs={12}>
                        <Grid container>
                          <Grid item xs={12}>
                            <label className="input-label">Card Number</label>
                            <TextField
                              name="dcNumber"
                              // label="Debit / ATM Number"
                              margin="normal"
                              variant="outlined"
                              fullWidth
                              placeholder="xxxx xxxx xxxx xxxx"
                              error={this.state.dcNumberErr}
                              helperText={this.state.dcNumberErrTxt}
                              className={classes.textField}
                              InputProps={{
                                inputComponent: this.CardInput,
                                value: this.state.dcNumber,
                                onChange: this.handleChange('dcNumber'),
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <i className="material-icons">
                                      credit_card
                                    </i>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item xs={9}>
                            <label className="input-label">Expiry Date</label>
                          </Grid>
                          <Grid item xs={3}>
                            <label className="input-label">CVV</label>
                          </Grid>
                          <Grid item xs={3}>
                            <TextField
                              name="dcExpMonth"
                              margin="normal"
                              variant="outlined"
                              fullWidth
                              placeholder={`MM`}
                              className={classes.textField}
                              error={this.state.dcExpMonthErr}
                              helperText={this.state.dcExpMonthErrTxt}
                              InputProps={{
                                inputComponent: MonthInput,
                                value: this.state.dcExpMonth,
                                onChange: this.handleChange('dcExpMonth'),
                              }}
                            />
                          </Grid>
                          <Grid item xs={1} />
                          <Grid item xs={3}>
                            <TextField
                              name="dcExpYear"
                              margin="normal"
                              variant="outlined"
                              fullWidth
                              placeholder={`YY`}
                              error={this.state.dcExpYearErr}
                              className={classes.textField}
                              helperText={this.state.dcExpYearErrTxt}
                              InputProps={{
                                inputComponent: YearInput,
                                value: this.state.dcExpYear,
                                onChange: this.handleChange('dcExpYear'),
                              }}
                            />
                          </Grid>
                          <Grid item xs={2} />
                          <Grid item xs={3}>
                            <TextField
                              type="password"
                              name="dcCVV"
                              margin="normal"
                              variant="outlined"
                              fullWidth
                              error={this.state.dcCVVErr}
                              className={classes.textField}
                              helperText={this.state.dcCVVErrTxt}
                              InputProps={{
                                inputComponent: CVVInput,
                                value: this.state.dcCVV,
                                onChange: this.handleChange('dcCVV'),
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <label className="input-label">Name on Card</label>
                            <TextField
                              name="dcName"
                              margin="normal"
                              variant="outlined"
                              fullWidth
                              error={this.state.dcNameErr}
                              className={classes.textField}
                              helperText={this.state.dcNameErrTxt}
                              value={this.state.dcName}
                              onChange={this.handleChange('dcName')}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel
                  classes={{
                    root: this.props.classes.root,
                  }}
                  expanded={this.state.expanded === 'panel2'}
                  onChange={this.handleExpansion('panel2')}
                >
                  <ExpansionPanelSummary
                    classes={{
                      root: this.props.classes.root,
                      content: this.props.classes.expansionPanelSummaryContent,
                    }}
                  >
                    <Radio
                      checked={this.state.selectedPaymentMethod === 'CC'}
                      name="selectedPaymentMethod"
                      aria-label="A"
                      classes={{
                        root: this.props.classes.radioBtnStyle,
                      }}
                    />
                    Credit Card
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails
                    classes={{
                      root: this.props.classes.expansionPanelDetailContent,
                    }}
                  >
                    <Grid container>
                      <Grid item xs={12}>
                        <Grid container>
                          <Grid item xs={12}>
                            <label className="input-label">
                              Credit Card Number
                            </label>
                            <TextField
                              name="ccNumber"
                              placeholder="xxxx xxxx xxxx xxxx"
                              margin="normal"
                              variant="outlined"
                              fullWidth
                              className={classes.textField}
                              error={this.state.ccNumberErr}
                              helperText={this.state.ccNumberErrTxt}
                              InputProps={{
                                inputComponent: this.CardInput,
                                value: this.state.ccNumber,
                                onChange: this.handleChange('ccNumber'),
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <i className="material-icons">
                                      credit_card
                                    </i>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item xs={9}>
                            <label className="input-label">Expiry Date</label>
                          </Grid>
                          <Grid item xs={3}>
                            <label className="input-label">CVV</label>
                          </Grid>
                          <Grid item xs={3}>
                            <TextField
                              name="ccExpMonth"
                              margin="normal"
                              variant="outlined"
                              fullWidth
                              placeholder={`MM`}
                              error={this.state.ccExpMonthErr}
                              helperText={this.state.ccExpMonthErrTxt}
                              className={classes.textField}
                              InputProps={{
                                inputComponent: MonthInput,
                                value: this.state.ccExpMonth,
                                onChange: this.handleChange('ccExpMonth'),
                              }}
                            />
                          </Grid>
                          <Grid item xs={1} />
                          <Grid item xs={3}>
                            <TextField
                              name="ccExpYear"
                              margin="normal"
                              variant="outlined"
                              placeholder={`YY`}
                              fullWidth
                              error={this.state.ccExpYearErr}
                              helperText={this.state.ccExpYearErrTxt}
                              className={classes.textField}
                              InputProps={{
                                inputComponent: YearInput,
                                value: this.state.ccExpYear,
                                onChange: this.handleChange('ccExpYear'),
                              }}
                            />
                          </Grid>
                          <Grid item xs={2} />
                          <Grid item xs={3}>
                            <TextField
                              type="password"
                              name="ccCVV"
                              margin="normal"
                              variant="outlined"
                              fullWidth
                              error={this.state.ccCVVErr}
                              helperText={this.state.ccCVVErrTxt}
                              className={classes.textField}
                              InputProps={{
                                inputComponent: CVVInput,
                                value: this.state.ccCVV,
                                onChange: this.handleChange('ccCVV'),
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <label className="input-label">Name on Card</label>
                            <TextField
                              name="ccName"
                              margin="normal"
                              variant="outlined"
                              fullWidth
                              error={this.state.ccNameErr}
                              className={classes.textField}
                              helperText={this.state.ccNameErrTxt}
                              value={this.state.ccName}
                              onChange={this.handleChange('ccName')}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ExpansionPanelDetails>
                </ExpansionPanel>

                {/* <ExpansionPanel
                  classes={{
                    root: this.props.classes.root
                  }}
                  expanded={this.state.expanded === "panel3"}
                  onChange={this.handleExpansion("panel3")}
                >
                  <ExpansionPanelSummary
                    classes={{
                      root: this.props.classes.root,
                      content: this.props.classes.expansionPanelSummaryContent
                    }}
                  >
                    <Radio
                      checked={this.state.selectedPaymentMethod === "TEZ"}
                      name="selectedPaymentMethod"
                      aria-label="A"
                      classes={{
                        root: this.props.classes.radioBtnStyle
                      }}
                    />
                    {"Google Pay (Tez)  "}
                    <img
                      src="https://www.confirmtkt.com/cdn-images/payment/GPay.png"
                      width={50}
                      height={20}
                      alt="Google Pay"
                      className="pgImg"
                    />
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails
                    classes={{
                      root: this.props.classes.expansionPanelDetailContent
                    }}
                  >
                    <Grid container>
                      <Grid item xs={12}>
                        <label className="input-label">Google Pay Id</label>
                        <TextField
                          name="gPayBankHandle"
                          margin="normal"
                          variant="outlined"
                          fullWidth
                          placeholder="example@oksbi"
                          error={this.state.gPayBankHandleErr}
                          className={classes.textField}
                          helperText={this.state.gPayBankHandleErrTxt}
                          value={this.state.gPayBankHandle}
                          onChange={this.handleChange("gPayBankHandle")}
                        />
                      </Grid>
                    </Grid>
                  </ExpansionPanelDetails>
                </ExpansionPanel> */}

                <ExpansionPanel
                  classes={{
                    root: this.props.classes.root,
                  }}
                  expanded={this.state.expanded === 'panel4'}
                  onChange={this.handleExpansion('panel4')}
                >
                  <ExpansionPanelSummary
                    classes={{
                      root: this.props.classes.root,
                      content: this.props.classes.expansionPanelSummaryContent,
                    }}
                  >
                    <Radio
                      checked={this.state.selectedPaymentMethod === 'upi'}
                      name="selectedPaymentMethod"
                      aria-label="A"
                      classes={{
                        root: this.props.classes.radioBtnStyle,
                      }}
                    />
                    UPI
                  </ExpansionPanelSummary>
                  {/* <ExpansionPanelDetails
                    classes={{
                      root: this.props.classes.expansionPanelDetailContent
                    }}
                  >
                    <Grid container>
                      <Grid item xs={12}>
                        <label className="input-label">UPI Id</label>
                        <TextField
                          name="upiBankHandle"
                          margin="normal"
                          variant="outlined"
                          fullWidth
                          placeholder="example@oksbi"
                          error={this.state.upiBankHandleErr}
                          className={classes.textField}
                          helperText={this.state.upiBankHandleErrTxt}
                          value={this.state.upiBankHandle}
                          onChange={this.handleChange("upiBankHandle")}
                        />
                      </Grid>
                    </Grid>
                  </ExpansionPanelDetails> */}
                </ExpansionPanel>

                <ExpansionPanel
                  classes={{
                    root: this.props.classes.root,
                  }}
                  expanded={this.state.expanded === 'panel6'}
                  onChange={this.handleExpansion('panel6')}
                >
                  <ExpansionPanelSummary
                    classes={{
                      root: this.props.classes.root,
                      content: this.props.classes.expansionPanelSummaryContent,
                    }}
                  >
                    <Radio
                      checked={this.state.selectedPaymentMethod === 'NB'}
                      name="selectedPaymentMethod"
                      aria-label="A"
                      classes={{
                        root: this.props.classes.radioBtnStyle,
                      }}
                    />
                    Net Banking
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails
                    classes={{
                      root: this.props.classes.expansionPanelDetailContent,
                    }}
                  >
                    <Grid container>
                      <Grid item xs={12}>
                        <Grid container>
                          <Grid item xs={12}>
                            <Grid container>
                              <Grid item xs={12}>
                                <label className="input-label">
                                  Select among Popular Banks
                                </label>
                                <Grid container>
                                  <Grid item xs={3} className="text-center">
                                    <img
                                      src="https://www.confirmtkt.com/img/Popular_bank/axis.png"
                                      alt="Axis Bank"
                                      width="38px"
                                      onClick={() =>
                                        this.handlePopularBank('AXIB')
                                      }
                                      className="popular-bank"
                                    />
                                    <div
                                      onClick={() =>
                                        this.handlePopularBank('AXIB')
                                      }
                                      className="popular-bank"
                                    >
                                      <strong>AXIS</strong>
                                    </div>
                                  </Grid>
                                  <Grid item xs={3} className="text-center">
                                    <img
                                      src="https://www.confirmtkt.com/img/Popular_bank/hdfc.png"
                                      alt="HDFC Bank"
                                      width="38px"
                                      onClick={() =>
                                        this.handlePopularBank('HDFB')
                                      }
                                      className="popular-bank"
                                    />
                                    <div
                                      onClick={() =>
                                        this.handlePopularBank('HDFB')
                                      }
                                      className="popular-bank"
                                    >
                                      <strong>HDFC</strong>
                                    </div>
                                  </Grid>
                                  <Grid item xs={3} className="text-center">
                                    <img
                                      src="https://www.confirmtkt.com/img/Popular_bank/icici.png"
                                      alt="ICICI Bank"
                                      width="38px"
                                      onClick={() =>
                                        this.handlePopularBank('ICIB')
                                      }
                                      className="popular-bank"
                                    />
                                    <div
                                      onClick={() =>
                                        this.handlePopularBank('ICIB')
                                      }
                                      className="popular-bank"
                                    >
                                      <strong>ICICI</strong>
                                    </div>
                                  </Grid>
                                  <Grid item xs={3} className="text-center">
                                    <img
                                      src="https://www.confirmtkt.com/img/Popular_bank/sbi.png"
                                      alt="SBI Bank"
                                      width="38px"
                                      onClick={() =>
                                        this.handlePopularBank('SBIB')
                                      }
                                      className="popular-bank"
                                    />
                                    <div
                                      onClick={() =>
                                        this.handlePopularBank('SBIB')
                                      }
                                      className="popular-bank"
                                    >
                                      <strong>SBI</strong>
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid container>
                          <Grid item xs={12}>
                            <Grid container>
                              <Grid item xs={12}>
                                <label
                                  className="input-label"
                                  style={{marginTop: '16px'}}
                                >
                                  Select your Bank
                                </label>
                                <FormControl variant="outlined" fullWidth>
                                  <Select
                                    native
                                    value={this.state.bankcode}
                                    onChange={this.handleChange('bankcode')}
                                    input={
                                      <OutlinedInput
                                        name="bankcode"
                                        labelWidth={1}
                                      />
                                    }
                                  >
                                    {bankList}
                                  </Select>
                                </FormControl>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel
                  classes={{
                    root: this.props.classes.root,
                  }}
                  expanded={this.state.expanded === 'panel7'}
                  onChange={this.handleExpansion('panel7')}
                >
                  <ExpansionPanelSummary
                    classes={{
                      root: this.props.classes.root,
                      content: this.props.classes.expansionPanelSummaryContent,
                    }}
                  >
                    <Radio
                      checked={this.state.selectedPaymentMethod === 'lazypay'}
                      name="selectedPaymentMethod"
                      aria-label="A"
                      classes={{
                        root: this.props.classes.radioBtnStyle,
                      }}
                    />
                    {'Pay Later '}
                    <img
                      src="https://www.confirmtkt.com/cdn-images/payment/logo_lazypay.png"
                      width={60}
                      height={15}
                      alt="Lazy Pay"
                      className="pgImg"
                    />
                  </ExpansionPanelSummary>
                </ExpansionPanel>

                {/* <ExpansionPanel
                  classes={{
                    root: this.props.classes.root,
                  }}
                  expanded={this.state.expanded === "panel8"}
                  onChange={this.handleExpansion("panel8")}
                >
                  <ExpansionPanelSummary
                    classes={{
                      root: this.props.classes.root,
                      content: this.props.classes.expansionPanelSummaryContent,
                    }}
                  >
                    <Radio
                      checked={this.state.selectedPaymentMethod === "mipay"}
                      name="selectedPaymentMethod"
                      aria-label="A"
                      classes={{
                        root: this.props.classes.radioBtnStyle,
                      }}
                    />
                    MI PAY
                    <img
                      width={80}
                      height={40}
                      src="https://www.confirmtkt.com/img/mi-pay-logo.jpg"
                      alt="confirmtkt-mipay"
                    />
                  </ExpansionPanelSummary>
                </ExpansionPanel> */}
              </MuiThemeProvider>
            </CardContent>
          </Card>
        )}
      </div>
    );

    const bottommenu = (
      <div className="bottom-fixed-details">
        <Grid container>
          <Grid
            item
            xs={6}
            onClick={this.handleDialogOpen}
            className="fare-info"
          >
            <div>
              <span>To Pay:&nbsp;&nbsp;</span>
              <span style={{fontSize: '2rem'}}>
                &#8377;&nbsp;{finalPayableAmount}
              </span>
            </div>
            <div style={{position: 'relative'}}>
              <span className="sm-text">Fare Details</span>
              <i className="material-icons">help_outline</i>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div
              variant="contained"
              style={{padding: '2rem'}}
              className="ctkt-btn-success-bottom"
              onClick={() => this.redirectPayment()}
            >
              CONTINUE
            </div>
          </Grid>
        </Grid>
      </div>
    );

    const header = (
      <Grid
        container
        justifyContent="flex-start"
        className="header-summary"
        style={{textAlign: 'center'}}
      >
        <Grid item xs={1} className="backBtn">
          <i
            className="material-icons"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            arrow_back
          </i>
        </Grid>
        <Grid item xs={10} className="title">
          Ticket Summary
        </Grid>
      </Grid>
    );

    return (
      <div className="ticket-summary">
        {header}
        {fareDetailsDialog}
        {GobacktoSeatLayout}

        {this.state.isloading ? (
          <div className="loading fixed">
            <CircularProgress />
          </div>
        ) : (
          ''
        )}

        {displayBlock}
        {bottommenu}
        {/* <Prompt message="are you sure u want to leave? " /> */}
        <Snackbar
          anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
          open={this.state.isSnackBarOpen}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          autoHideDuration={4000}
          message={this.state.message}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ticketdetailsReducer: state.ticketdetailsReducer,
    searchQuery: state.searchReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

TicketSummary.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(TicketSummary));
